export const CREATE_GOAL = 'CREATE_GOAL'
export const CREATE_GOAL_LOADING = 'CREATE_GOAL_LOADING'
export const CREATE_GOAL_SUCCESS = 'CREATE_GOAL_SUCCESS'
export const CREATE_GOAL_ERROR = 'CREATE_GOAL_ERROR'

export const LOAD_VIEW_GOALS_PAGE = 'LOAD_VIEW_GOALS_PAGE'
export const LOAD_VIEW_GOALS_PAGE_LOADING = 'LOAD_VIEW_GOALS_PAGE_LOADING'
export const LOAD_VIEW_GOALS_PAGE_SUCCESS = 'LOAD_VIEW_GOALS_PAGE_SUCCESS'
export const LOAD_VIEW_GOALS_PAGE_ERROR = 'LOAD_VIEW_GOALS_PAGE_ERROR'

export const GET_USER_GOALS = 'GET_USER_GOALS'
export const GET_USER_GOALS_LOADING = 'GET_USER_GOALS_LOADING'
export const GET_USER_GOALS_SUCCESS = 'GET_USER_GOALS_SUCCESS'
export const GET_USER_GOALS_ERROR = 'GET_USER_GOALS_ERROR'

export const GET_GOAL_PROGRESS = 'GET_GOAL_PROGRESS'
export const GET_GOAL_PROGRESS_LOADING = 'GET_GOAL_PROGRESS_LOADING'
export const GET_GOAL_PROGRESS_SUCCESS = 'GET_GOAL_PROGRESS_SUCCESS'
export const GET_GOAL_PROGRESS_ERROR = 'GET_GOAL_PROGRESS_ERROR'

export const STOP_GOAL = 'STOP_GOAL'
export const STOP_GOAL_LOADING = 'STOP_GOAL_LOADING'
export const STOP_GOAL_SUCCESS = 'STOP_GOAL_SUCCESS'
export const STOP_GOAL_ERROR = 'STOP_GOAL_ERROR'
